<template>
  <div class="ds-detail">
    <el-alert v-if="loadError" :title="loadError" type="warning" :closable="false" show-icon />
    <template v-else>
    <div class="ds-head">
      <div class="ds-head-main">
        <img v-if="coverSrc" :src="coverSrc" class="ds-cover" alt="">
        <GsMediaPh v-else class="ds-cover" label="暂无封面" />
        <div class="ds-head-copy">
          <p class="ds-kicker">数据集档案</p>
          <h1 class="ds-title">{{ pageTitle }}</h1>
          <div class="ds-sub">
            <span>所属企业：</span>
            <EnterpriseLink :id="enterpriseId" :name="enterpriseName" />
          </div>
          <div v-if="tagList.length" class="ds-tags">
            <span v-for="(tag, index) in tagList" :key="index" class="ds-tag">{{ tag }}</span>
          </div>
        </div>
      </div>
      <div class="ds-intro">
        <span class="ds-intro-label">数据简介：</span>
        <div v-if="introText" class="ds-intro-text">{{ introText }}</div>
        <div v-else class="gs-text-ph">该数据集暂未公开简介，后续将补充数据范围、来源与使用说明。</div>
      </div>
    </div>

    <div class="ds-block">
      <TitleTool title="登记信息" />
      <div class="ds-panel">
        <div class="ds-grid is-3">
          <div class="ds-field" v-for="item in registerFields" :key="item.label">
            <span class="ds-label">{{ item.label }}：</span>
            <div class="ds-value">
              <EnterpriseLink v-if="item.enterpriseId" :id="item.enterpriseId" :name="item.value" />
              <GsVal v-else :value="item.value" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ds-block">
      <TitleTool title="规格与场景" />
      <div class="ds-panel">
        <div class="ds-grid is-2">
          <div class="ds-field" v-for="item in specFields" :key="item.label">
            <span class="ds-label">{{ item.label }}：</span>
            <div class="ds-value"><GsVal :value="item.value" /></div>
          </div>
        </div>
        <div class="ds-field is-wide">
          <span class="ds-label">数据内容详情：</span>
          <div class="ds-value is-long"><GsVal :value="ruleForm.dataContentIntroduction" /></div>
        </div>
      </div>
    </div>

    <div class="ds-block">
      <TitleTool title="确权与凭证" />
      <div class="ds-panel">
        <div class="ds-right-grid">
          <div class="ds-right" v-for="item in rightFields" :key="item.label">
            <div class="ds-right-title">{{ item.label }}</div>
            <div class="ds-right-body">
              <img v-if="imgUrl(item.value)" :src="imgUrl(item.value)" :alt="item.label" class="ds-right-img" />
              <span v-else-if="item.value" class="ds-right-text">{{ item.value }}</span>
              <span v-else class="ds-right-empty">暂无</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ds-actions">
      <el-button v-if="ruleForm.localBusinessId" type="primary" @click="$router.push({ path: '/demand/assistant', query: { dataset: ruleForm.localBusinessId } })">咨询采购这份数据</el-button>
      <button type="button" class="ds-btn is-ghost" @click="goHall">在交易大厅查看挂牌</button>
    </div>
    </template>
  </div>
</template>

<script>
import { getDatasetDetail, getTradeList } from '@/api/api'
import { enumType } from '@/utils/enum.js'
import { getDataType } from '@/api/Layout/index.js'
import { P, routeId } from '@/router/paths'
import GsVal from '@/components/GsVal/index.vue'
import GsMediaPh from '@/components/GsMediaPh/index.vue'
import EnterpriseLink from '@/components/EnterpriseLink/index.vue'

export default {
  name: 'DatasetDetail',
  components: { GsVal, GsMediaPh, EnterpriseLink },
  data() {
    return {
      ruleForm: {},
      loadError: '',
      registrationDataList: [],
      agingList: [],
      prodUrl: 'https://shujuzichan.com/xwzx'
    }
  },
  computed: {
    pageTitle() {
      return this.ruleForm.registrationDataName || this.ruleForm.dataName || '未命名数据集'
    },
    enterpriseId() {
      return this.ruleForm.enterpriseId || ''
    },
    enterpriseName() {
      return this.ruleForm.enterpriseName || this.ruleForm.registrationPrincipalName || '未关联企业'
    },
    coverSrc() {
      const src = this.ruleForm.coverPicture || this.ruleForm.logoPicture || ''
      if (!src) return ''
      if (/^https?:\/\//i.test(src)) return src
      return this.prodUrl + src
    },
    introText() {
      return (this.ruleForm.dataContentIntroduction || '').toString().trim()
    },
    tagList() {
      return [
        this.transFormEnum(this.registrationDataList, this.ruleForm.registrationDataType),
        this.ruleForm.industryName || this.ruleForm.industryClassification,
        this.ruleForm.registrationPlatform,
        this.agingLabel
      ].filter((item) => item && String(item).trim())
    },
    agingLabel() {
      return this.transFormEnum(this.agingList, this.ruleForm.dataAging) || this.ruleForm.dataAging
    },
    registerFields() {
      return [
        { label: '登记数据名称', value: this.ruleForm.registrationDataName },
        { label: '登记主体', value: this.ruleForm.registrationPrincipalName },
        { label: '所属企业', value: this.ruleForm.enterpriseName, enterpriseId: this.enterpriseId },
        { label: '登记数据类型', value: this.transFormEnum(this.registrationDataList, this.ruleForm.registrationDataType) },
        { label: '登记机构', value: this.ruleForm.registrationOrganization },
        { label: '登记平台', value: this.ruleForm.registrationPlatform },
        { label: '行政区划', value: this.ruleForm.administrativeDivisionName || this.ruleForm.registeredAddressName },
        { label: '行业分类', value: this.ruleForm.industryName || this.ruleForm.industryClassification },
        { label: '共有主体', value: this.ruleForm.commonPrincipalName },
        { label: '公示周期', value: this.ruleForm.publicityCycle },
        { label: '登记地址', value: this.ruleForm.registeredAddressDetail },
        { label: '登记信息', value: this.ruleForm.registrationInformation },
        { label: '证书编号', value: this.ruleForm.certificateNumber },
        { label: '有效期限', value: this.ruleForm.validUntil },
        { label: '登记日期', value: this.ruleForm.registrationDate },
        { label: '盖章单位', value: this.ruleForm.sealUnit },
        { label: '监制机构', value: this.ruleForm.supervisingAgency },
        { label: '数据数量', value: this.ruleForm.dataAmount },
        { label: '状态', value: this.ruleForm.dataStatus }
      ]
    },
    specFields() {
      return [
        { label: '产品参数', value: this.ruleForm.productSpecification },
        { label: '应用场景', value: this.ruleForm.dataApplicationScenarios || this.ruleForm.applicationScenario },
        { label: '数据时效', value: this.agingLabel },
        { label: '可信数据空间', value: this.ruleForm.trustedDataSpacePlatform },
        { label: '调用方式接口', value: this.ruleForm.interfaceInformation },
        { label: '数据交易形式', value: this.ruleForm.priceDescription },
        { label: '数据服务说明', value: this.ruleForm.dataServiceDesc },
        { label: '其他内容（数据集）', value: this.ruleForm.otherContent },
        { label: '其他内容（数据服务）', value: this.ruleForm.otherContentService },
        { label: '其他内容（其他）', value: this.ruleForm.otherContentOther }
      ]
    },
    /** 确权与凭证：三项权属在前（子标题 + 上传图片），其余登记/服务凭证在后 */
    rightFields() {
      return [
        { label: '数据资源持有权', value: this.ruleForm.dataResourceOwnership },
        { label: '数据产品经营权', value: this.ruleForm.resourceManagementRight },
        { label: '数据加工使用权', value: this.ruleForm.dataProcessingRight },
        { label: '数据确权认证', value: this.ruleForm.dataRightsCertification || this.ruleForm.registrationCertificate },
        { label: '数据资源登记证', value: this.ruleForm.intellectualRegistrationCertificate },
        { label: '数据持有凭证', value: this.ruleForm.dataHoldingCertificate },
        { label: '数据服务凭证', value: this.ruleForm.dataServiceCertificate }
      ]
    },
    transFormEnum() {
      return function (enumList, value) {
        if (!value) return ''
        const valObj = String(value).split(',').map((item) => item.trim())
        const labels = []
        if (enumList && enumList.length > 0) {
          enumList.forEach((item) => {
            valObj.forEach((itemObj) => {
              if (itemObj === item.value) labels.push(item.label)
            })
          })
        }
        return labels.join(',')
      }
    }
  },
  created() {
    this.loadDetail()
    this.getData('sys_enterprise_register_data_type')
    this.getData('sys_data_aging')
  },
  watch: {
    '$route.params.id'() {
      this.loadDetail()
    }
  },
  methods: {
    /** 凭证/权属字段可能存相对路径，统一补全域名前缀 */
    imgUrl(value) {
      const src = String(value || '').trim()
      if (!src) return ''
      if (/^https?:\/\//i.test(src)) return src
      if (/\.(png|jpe?g|gif|webp|svg)(\?|$)/i.test(src) || src.startsWith('/')) return this.prodUrl + src
      return ''
    },

    async getData(type) {
      try {
        const res = await getDataType(type)
        if (res && res.data && res.data.length > 0) {
          const list = enumType(res.data)
          if (type === 'sys_enterprise_register_data_type') this.registrationDataList = list
          if (type === 'sys_data_aging') this.agingList = list
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    loadDetail() {
      const id = routeId(this.$route)
      if (!id) return
      this.loadError = ''
      getDatasetDetail(id).then((response) => {
        this.ruleForm = response.data || {}
        if (!response.data) this.loadError = '数据集未公开、已暂停供应或不存在。'
      }).catch(() => { this.ruleForm = {}; this.loadError = '数据集暂不可查看，请返回列表确认供应状态。' })
    },
    goHall() {
      if (this.ruleForm.localBusinessId) return this.$router.push({ path: P.hall, query: { dataset: this.ruleForm.localBusinessId } })
      const id = this.ruleForm.id || routeId(this.$route)
      if (!id) {
        this.$router.push(P.hall)
        return
      }
      getTradeList({ pageNum: 1, pageSize: 1, datasetId: id, whetherPublish: '1' }).then((res) => {
        const row = res && res.rows && res.rows[0]
        if (row && row.id) this.$router.push(P.hallDetail(row.id))
        else this.$router.push(P.hall)
      }).catch(() => {
        this.$router.push(P.hall)
      })
    }
  }
}
</script>

<style scoped lang="css">
.ds-detail {
  width: 100%;
  max-width: none;
  margin: 0 auto;
  padding: 8px 0 48px;
}
.ds-head {
  background: #fff;
  border-radius: 12px;
  padding: 22px;
  margin-bottom: 16px;
  box-shadow: 0 8px 20px rgba(1, 101, 255, 0.04);
}
.ds-head-main {
  display: flex;
  align-items: center;
  gap: 20px;
  min-height: 106px;
}
.ds-cover {
  width: 106px;
  height: 106px;
  border-radius: 10px;
  object-fit: cover;
  flex-shrink: 0;
}
.ds-kicker {
  margin: 0 0 6px;
  font-size: 12px;
  letter-spacing: 1px;
  color: #0165FF;
  font-weight: 700;
}
.ds-title {
  margin: 0 0 10px;
  font-size: 28px;
  line-height: 36px;
  color: #111824;
  font-weight: 700;
}
.ds-sub {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 15px;
  color: #333;
}
.ds-link,
.ds-btn {
  border: 0;
  background: none;
  padding: 0;
  color: #0165FF;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
}
.ds-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.ds-tag {
  background: #EEF4FF;
  color: #1D2B44;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  line-height: 16px;
}
.ds-intro {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #F0F4FA;
}
.ds-intro-label {
  flex-shrink: 0;
  width: 84px;
  font-size: 15px;
  color: #333;
  line-height: 22px;
}
.ds-intro-text {
  flex: 1;
  font-size: 14px;
  line-height: 22px;
  color: #4B5563;
}
.gs-text-ph {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: linear-gradient(90deg, #F4F8FF 0%, #FFFFFF 100%);
  border: 1px dashed #C5D8F7;
  color: #7B8BA3;
  font-size: 13px;
  line-height: 22px;
}
.ds-block {
  background: #F7F9FC;
  border-radius: 8px;
  padding: 18px 16px 12px;
  margin-bottom: 16px;
}
.ds-sec-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 20px;
  font-weight: 700;
  color: #111824;
  line-height: 24px;
}
.ds-sec-icon {
  width: 28px;
  height: 18px;
}
.ds-panel {
  background: #fff;
  border-radius: 8px;
  padding: 8px 8px 4px;
}
.ds-grid {
  display: grid;
}
.ds-grid.is-3 {
  grid-template-columns: 1fr 1fr 1fr;
}
.ds-grid.is-2 {
  grid-template-columns: 1fr 1fr;
}
.ds-field {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 8px 10px;
  border-right: 1px solid rgba(118, 118, 118, 0.13);
  border-bottom: 1px solid rgba(118, 118, 118, 0.08);
}
.ds-grid .ds-field:nth-child(3n) {
  border-right: none;
}
.ds-grid.is-2 .ds-field:nth-child(2n) {
  border-right: none;
}
.ds-field.is-wide {
  border-right: none;
  align-items: flex-start;
  padding: 12px 10px 16px;
}
.ds-label {
  flex-shrink: 0;
  width: 118px;
  font-size: 14px;
  color: #333;
  line-height: 22px;
}
.ds-value {
  flex: 1;
  min-width: 0;
  min-height: 32px;
  display: flex;
  align-items: center;
  padding: 4px 10px;
  background: #F4F6F8;
  border-radius: 6px;
}
.ds-value.is-long {
  align-items: flex-start;
  min-height: 64px;
  padding: 10px;
}
.ds-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.ds-btn {
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  background: #0165FF;
  color: #fff;
  font-size: 14px;
}
.ds-btn.is-ghost {
  background: #fff;
  color: #0165FF;
  border: 1px solid #0165FF;
}
@media (max-width: 960px) {
  .ds-title {
    font-size: 22px;
    line-height: 30px;
  }
  .ds-grid.is-3,
  .ds-grid.is-2 {
    grid-template-columns: 1fr;
  }
  .ds-field,
  .ds-grid .ds-field:nth-child(3n),
  .ds-grid.is-2 .ds-field:nth-child(2n) {
    border-right: none;
  }
  .ds-label {
    width: 96px;
    font-size: 13px;
  }
}
.ds-right-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}
.ds-right {
  background: #F7F9FD;
  border: 1px solid #E8EEF7;
  border-radius: 8px;
  padding: 10px 12px;
  min-height: 132px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ds-right-title {
  font-size: 13px;
  font-weight: 600;
  color: #111824;
  padding-left: 8px;
  position: relative;
}
.ds-right-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  width: 3px;
  height: 12px;
  transform: translateY(-50%);
  background: #0165FF;
  border-radius: 2px;
}
.ds-right-body {
  flex: 1;
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px dashed #D8E3F5;
  border-radius: 6px;
  overflow: hidden;
}
.ds-right-img {
  width: 100%;
  height: 100%;
  max-height: 110px;
  object-fit: contain;
  display: block;
}
.ds-right-text { font-size: 12px; color: #5E6166; word-break: break-all; }
.ds-right-empty { font-size: 12px; color: #9AA7BB; }
@media (max-width: 1249px) {
  .ds-right-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
</style>
